import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductOptionPicker } from './ProductOptionPicker';
import { ProductForm } from './ProductForm';
import { render, html } from 'lit-html';
@Component
export class ProductStickyBar extends ThemeComponent {
    @Ref({ required: false }) editButton: HTMLElement | null = null;
    @Ref({ required: false }) stickyBannerProductOptions!: HTMLElement[];
    @Ref({ required: false }) options!: ProductOptionPicker;
    @Ref({ required: false }) stickyBanner!: ProductStickyBar;
    @Ref() selectedOption!: HTMLDivElement[];
    @Ref() submitButton!: HTMLButtonElement;

    private observer?: IntersectionObserver;
    private element: HTMLElement|null = document.querySelector('.product-sticky');
    private productMain: HTMLElement|null = document.querySelector('.product-main__details');
    private stickyBarSelection: HTMLElement|null = document.querySelector('accordion-container');
    private productForm: ProductForm|null = null;

    init() {
        this.element = document.querySelector('.product-sticky') as HTMLElement;
        if (!this.element) {
            return;
        }

        if (!this.observer) {  // Initialize the observer only once
            this.initializeObserver();
        }

        // Listen for click even on edit button
        this.setupEditButtonListener();

        // Assign Product form
        if (this.productMain) {
            this.productForm = this.productMain.querySelector('product-form');
        }

        if (this.productForm) {
            // Listen for when variant selection changes
            this.$subscribe(this.productForm.onVariantChange, (variant: Shopify.Liquid.Variant) => {
                // Handle the new variant
                this.handleVariantChange(variant);
                if(this.stickyBarSelection) {
                    this.stickyBarSelection.classList.remove('accordion--hide');
                }
            });
        }
    }

    private handleVariantChange(variant: Shopify.Liquid.Variant) {
        // When the product form variant changes, update the selected variant
        for (const selectedOption of this.selectedOption) {
            render(html`
                    ${variant.options}
            `, selectedOption);
        }
    }

    private setupEditButtonListener() {
        if (this.editButton) {
            this.editButton.addEventListener('click', this.handleEditButtonClick.bind(this));
        }
    }

    private handleEditButtonClick() {
        if (this.productMain) {
            this.productMain.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    private initializeObserver() {
        this.element = document.querySelector('.product-sticky') as HTMLElement;
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        this.observer = new IntersectionObserver((entries) => {
            let submitVisible = false;
            let footerVisible = false;
            for (const entry of entries) {  // Using for-of loop here
                if (entry.target.classList.contains('product-form__submit')) {
                    submitVisible = entry.isIntersecting;
                }
                if (entry.target.classList.contains('site-footer')) {
                    footerVisible = entry.isIntersecting;
                }
            }

            // Show sticky bar only if both the submit button or the footer are visible
            this.toggleStickyBar(submitVisible || footerVisible);

        }, options);

        // Observe the submit button and the footer
        const submitTarget = document.querySelector('.product-form__submit');
        const footerTarget = document.querySelector('.site-footer');

        if (submitTarget) {
            this.observer.observe(submitTarget);
        }
        if (footerTarget) {
            this.observer.observe(footerTarget);
        }
    }

    private toggleStickyBar(show: boolean) {
        if (this.element) {
            this.element.classList.toggle('product-sticky--hidden', show);
        }
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}

